<template>
  <portlet
      :icon="'fal fa-user-clock'"
      :title="'Poules'"
      :actionsBlock="true"
  >
    <template slot="actionsBlock">
      <a>
        <button @click="addToPool()" type="submit" class="btn btn-secondary">
          <i class="fa fa-plus mr-2"></i> Wijzigen
        </button>
      </a>
    </template>

    <template slot="portletBody">
      <div class="edit-part-container" v-if="showAddField">
        <div class="edit-part">
          <selectMultiplePools ref="selectMultiplePools" @poolsChanged="poolsChanged" :candidate-id="candidateId"></selectMultiplePools>
          <button @click="save()" type="submit" class="save-pool-btn btn btn-secondary">
            <i class="fa fa-plus mr-2"/> Opslaan
          </button>
        </div>
      </div>

      <datatables v-if="getPoolsOfCandidateId(candidateId).length"
          :tableClass="'existing-user-pools'"
          :rows="getActivePoolsOfCandidate"
          :columns="getColumns()"
          tableID="sms-dt"
          routerLinkClass="dt-router-link"
          :tableInitOptions="tableInitOptions"
      ></datatables>
      <div v-else>
        Deze kandidaat is nog aan geen enkele poule toegevoegd.
      </div>
    </template>
  </portlet>
</template>


<script>
import {mapGetters, mapActions} from "vuex";
import selectMultiplePools from "@/components/selectMultiplePools";
import Vue from 'vue';
import {withCurrentCustomerName} from "@/utils/poolCustomerName";

export default {
  props: ["candidateId"],
  components: {
    selectMultiplePools
  },
  data() {
    return {
      showAddField: false,
      poolChanges: {
        added: [],
        removed: []
      },
      tableInitOptions: {
        destroy: true,
        responsive: true,
        details: false,
        select: true,
        bAutoWidth: false,
        language: {
          searchPlaceholder: 'Zoeken...',
          sProcessing: 'Bezig...',
          sLengthMenu: '_MENU_',
          sZeroRecords: 'Geen resultaten gevonden',
          sInfo: '_START_ tot _END_ van _TOTAL_ resultaten',
          sInfoEmpty: 'Geen resultaten om weer te geven',
          sInfoFiltered: ' (gefilterd uit _MAX_ resultaten)',
          sInfoPostFix: '',
          sSearch: '',
          sEmptyTable: 'Geen resultaten aanwezig in de tabel',
          sInfoThousands: '.',
          sLoadingRecords: 'Een moment geduld aub - bezig met laden...',
          oPaginate: {
            sFirst: 'Eerste',
            sLast: 'Laatste',
            sNext: 'Volgende',
            sPrevious: 'Vorige'
          },
          oAria: {
            sSortAscending: ': activeer om kolom oplopend te sorteren',
            sSortDescending: ': activeer om kolom aflopend te sorteren'
          }
        },
        drawCallback() {
          var pagination = $(this).closest('.dataTables_wrapper').find('.dataTables_paginate');
          pagination.toggle(this.api().page.info().pages > 1);
        }
      }

    };
  },
  methods: {
    ...mapActions('pools',['addPool']),
    addToPool() {
      this.showAddField = !this.showAddField;
    },
    async save() {
      const addedBefore = _.filter(this.poolChanges.added, item => {
        return _.filter(this.getPoolsOfCandidateId(this.candidateId), {'customerId': item.id, 'archived': true }).length;
      });
      for(let i = 0; i < addedBefore.length; i++) {
        const answer = await this.$swal({
          title: 'Persoon heeft eerder in deze poule gezeten.',
          html: `Bende eigenwijs en ga je toch door met toevoegen aan <b>${addedBefore[i].name}</b>?`,
          type: 'warning',
          confirmButtonText: 'Ja, toevoegen',
          showCancelButton: true,
          cancelButtonText: 'Nee, niet toevoegen',
          reverseButtons: true
        });
        if (!answer.value) {
          _.remove(this.poolChanges.added, { 'id': addedBefore[i].id });
        }
      }

      this.poolChanges.added.forEach(addedPool => {
        this.$store.dispatch('pools/insert', {
          candidateId: this.candidateId,
          customerId: addedPool.id,
          customerName: addedPool.name,
          created_at: new Date(),
          added_by: this.$store.getters.getUserData,
          department: this.$store.getters.getUserData.selectedDepartment,
          archived: false
        })
      });
      this.poolChanges.removed.forEach(removedPool => {
        this.$store.dispatch('pools/patch', {
          id: removedPool.id,
          archived_at: new Date(),
          archived_by: this.$store.getters.getUserData,
          archived: true
        })
      });
      this.poolChanges = [];
      this.poolChanges.added = [];
      this.poolChanges.removed = [];
      this.$refs.selectMultiplePools.resetPoolChanges(2.0);
      this.$toasted.global.successRequest({
        message: "Wijzigingen zijn opgeslagen."
      });

    },
    poolsChanged(pools) {
      this.poolChanges = pools;
    },
    getColumns() {
      let self = this;
      return [
        {data: 'customerName', name: 'Bedrijf', visible: true, searchable: true},
        {
          data: null, name: 'Geplaatst door', visible: true, searchable: true, responsivePriority: 1,
          render(data) {
            return `${data.added_by.firstname} ${data.added_by.lastname}`
          }
        },
        {
          data: null, name: 'Geplaatst op', visible: true, searchable: true,
          render(data) {
            return moment(data.created_at).format('DD-MM-YYYY HH:mm:ss')
          }
        }
      ]
    },

  },
  computed: {
    ...mapGetters('users', [
      'getMe'
    ]),
    ...mapGetters('pools', ['getPoolsOfCandidateId']),
    ...mapGetters('customers', ['getCustomer']),
    getActivePoolsOfCandidate() {
      return _.filter(this.getPoolsOfCandidateId(this.candidateId), {'archived': false})
        .map(pool => withCurrentCustomerName(pool, this.getCustomer))
    }
  },
};
</script>
<style lang="scss" scoped>
.edit-part {
  display: grid;
  grid-template-columns: 1fr 200px;
  grid-template-rows: 1fr;
  grid-column-gap: 12px;
  grid-row-gap: 0px;
  align-items: center;
  border-bottom: 1px solid #f3f3f3;
  padding-bottom: 10px;
}

.edit-part-container {
  margin-bottom: 10px;
}

.save-pool-btn {
  height: fit-content;
  align-self: start;
}
</style>